import { Box, IconButton, Input, Stack, TableCell, TableRow, TextField } from '@mui/material'
import React, { useRef } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import DoneIcon from '@mui/icons-material/Done';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CancelIcon from '@mui/icons-material/Close';

const EditRowMoverAdd = ({ row, handleUpdate, setEditRowId }) => {
    const moverRef = useRef();
    const priceRef = useRef();
    
    const handleUpdateClick = (event, row) => {
        event.preventDefault();
        let mover = parseInt(moverRef.current.value);     //Cantidad a mover del almacen a la tienda
        let currentPrice = parseFloat(priceRef.current.value);     //Nuevo precio del producto
        //const costo = parseFloat(costoRef.current.value);
        //const total = (cantidad * costo)

        if(mover > row.totalFinal) 
            mover = row.totalFinal;

        const newRow = {...row, currentPrice, mover}
        //console.log({newRow, currentPrice, mover})
        handleUpdate(newRow);

        //setDisponibilidadProducto(newRow);
    }

    const handleCancelClick = (event, row) => {
        event.preventDefault();
        setEditRowId(0);
    }

    return (
        <TableRow key={row.lot}>
            <TableCell key={row.lot + '_lot'} align='left'>{row.lot}</TableCell>
            <TableCell key={row.lot + '_cost'} align='left'>{row.cost}</TableCell>

            <TableCell key={row.lot + '_price'} align='left'>
                <Box sx={{width: '100px'}}>
                    <TextField size='small' type='number' inputRef={priceRef} required='required' placeholder='0.00' name='price' defaultValue={row.currentPrice}  />
                </Box>
            </TableCell>


            <TableCell key={row.lot + '_exp'} align='left'>{row.expD}</TableCell>
            <TableCell key={row.lot + '_tot'} align='left'>{row.totalFinal}</TableCell>

            <TableCell key={row.lot + '_mov'} align='left'>
                <Box sx={{width: '100px'}}>
                    <TextField size='small' type='number' inputRef={moverRef} required='required' placeholder='0' name='mover' defaultValue={row.mover}  />
                </Box>
            </TableCell>

            <TableCell key={'controles_' + row.id} align='left'>
            <Stack direction='row' spacing={0}>
                    <IconButton aria-label="save" onClick={(event) => handleUpdateClick(event, row)}>
                        <DoneIcon fontSize="small" />
                    </IconButton>
                    <IconButton aria-label="cancel" onClick={(event) => handleCancelClick(event, row)}>
                        <CancelIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}

export default EditRowMoverAdd